import React from "react";
import { formatDateFull } from "../../utils/helper";

export const InventoryNotification = ({ item }) => {
  const [qty, min_qty, part, location, vendor] = item.description.split("|");
  return (
    <div sx={{ fontSize: 12, marginTop: "5px" }}>
      <div className={"row"} spacing={1}>
        <div className={"col-sm-12"}>
          <b>Inventory Quantity Update</b>
        </div>
        <div className={"col-sm-4"}>Status</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>
          {" "}
          {min_qty >= qty ? (
            <span className="badge bg-danger">Low Stock</span>
          ) : (
            <span className="badge bg-success">In Stock</span>
          )}
        </div>

        <div className={"col-sm-4"}>Part</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{part}</div>

        <div className={"col-sm-4"}>Location</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{location}</div>

        <div className={"col-sm-4"}>Vendor</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{vendor}</div>
      </div>
    </div>
  );
};
